/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var ExternalStatus;
(function (ExternalStatus) {
    ExternalStatus["ALL_ELIGIBLE"] = "ALL_ELIGIBLE";
    ExternalStatus["TO_BE_RAISED"] = "TO_BE_RAISED";
    ExternalStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ExternalStatus["ACCEPTED"] = "ACCEPTED";
    ExternalStatus["DENIED"] = "DENIED";
    ExternalStatus["EXPIRED"] = "EXPIRED";
    ExternalStatus["NO_CHARGEBACK"] = "NO_CHARGEBACK";
    ExternalStatus["CHARGEBACKS_NOT_ENABLED"] = "CHARGEBACKS_NOT_ENABLED";
    ExternalStatus["LOCATION_NOT_ENABLED_FOR_CHARGEBACKS"] = "LOCATION_NOT_ENABLED_FOR_CHARGEBACKS";
    ExternalStatus["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(ExternalStatus || (ExternalStatus = {}));
